export default __webpack_public_path__ + "static/media/MAZDA.03a0ff4a.png";